import { ApiProperty } from "@nestjs/swagger";
import { ReWeighingDto } from "./re-weighment.dto";

export class ReWeighingItemsDto {
    @ApiProperty()
    rmItemWeighData: ReWeighingDto[];
}